import React from 'react';
import { Box, Slider, Typography } from '@mui/material';

export default function YearRangeSlider({
  label,
  value,
  onChange,
  onChangeCommitted,
  min = 1901,
  max = new Date().getFullYear(),
  disabled = false
}) {
  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  const handleChangeCommitted = (event, newValue) => {
    if (onChangeCommitted) onChangeCommitted(newValue);
  };

  const valueText = (value) => `${value}`;

  return (
    <Box sx={{ px: 1 }}>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {label}: {value[0]} - {value[1]}
      </Typography>
      <Slider
        value={value}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        valueLabelDisplay="auto"
        valueLabelFormat={valueText}
        min={min}
        max={max}
        disabled={disabled}
        marks={[
          { value: min, label: String(min) },
          { value: max, label: String(max) }
        ]}
        sx={{
          '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
          },
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
          }
        }}
      />
    </Box>
  );
}
